var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLeftArrow = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.772,
    height: 45,
    viewBox: "0 0 27.772 45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M19.622,28.688,38,11.674a3.038,3.038,0,0,0,0-4.541,3.686,3.686,0,0,0-4.917,0L12.262,26.41a3.042,3.042,0,0,0-.1,4.434L33.071,50.256a3.691,3.691,0,0,0,4.917,0,3.038,3.038,0,0,0,0-4.541Z",
    transform: "translate(-11.251 -6.194)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeftArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/left-arrow.8210f7a5.svg";
export { ForwardRef as ReactComponent };